import React, { createContext, useContext, useState } from "react";

const GlobalNetworkStateContext = createContext();

export const GlobalNetworkStateProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const showLoading = () => setLoading(true);
  const hideLoading = () => setLoading(false);

  return (
    <GlobalNetworkStateContext.Provider value={{ loading, showLoading, hideLoading }}>
      {children}
    </GlobalNetworkStateContext.Provider>
  );
};

export const useGlobalNetworkState = () => useContext(GlobalNetworkStateContext);